<template>
  <ModalCardDefault
    :title="`Saldo a receber — ${distributorName}`"
    @close="$emit('close')"
  >
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

    <template v-else-if="balance || recipient">
      <Tabs v-model="tab" @setTab="setTab">
        <Tab v-for="item in tabItems" :key="item">{{ item }}</Tab>
      </Tabs>

      <TabsItems v-model="tab" class="mt-4">
        <component
          :is="componentTabItem"
          :balance="balance"
          :recipient="recipient"
        />
      </TabsItems>
    </template>

    <div v-else class="text-center py-6">
      Não foi possível carregar os dados deste distribuidor.
    </div>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import { Tabs, Tab, TabsItems } from '@/components/vuetify';
import AdminDistributorPagarmeBalanceTab from './AdminDistributorPagarmeBalanceTab.vue';
import AdminDistributorPagarmeRecipientTab from './AdminDistributorPagarmeRecipientTab.vue';

const TAB_COMPONENTS = [
  AdminDistributorPagarmeBalanceTab,
  AdminDistributorPagarmeRecipientTab,
];

export default {
  name: 'AdminDistributorBalanceModal',
  components: {
    ModalCardDefault,
    Tabs,
    Tab,
    TabsItems,
  },
  props: {
    distributorId: {
      type: String,
      required: true,
    },
    distributorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      balance: null,
      recipient: null,
      tab: 0,
      tabItems: ['Saldo', 'Recebedor'],
      componentTabItem: AdminDistributorPagarmeBalanceTab,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
      this.componentTabItem = TAB_COMPONENTS[tab];
    },
    fetchData() {
      this.loading = true;
      this.$api.admin
        .getDistributorRecipientDetails(this.distributorId)
        .then(({ data }) => {
          this.balance = data.balance || null;
          this.recipient = data.recipient || null;
        })
        .catch(() => {
          this.$noty.error('Erro ao carregar dados do distribuidor');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
